import React, { Fragment, Component } from "react";
import Title from "./Title";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { notification, Spin, Tabs } from "antd";
import { getCorporateGroups } from "../../Graphs/CorporateGroups/lsitCorporateGroups";
import CorporateGroupRecordsTable from "./CorporateGroupRecordsTable";
import { AddCorporateUser } from "./AddCorporate";
import { checkPermission } from "../AdminUser/CheckPremission";
import {
  ACCESS_DENIED_MESSAGE,
  ACCESS_DENIED_MESSAGE_DESCRIPTION,
} from "../../constant/comman";

class Group extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      activeTabKey: "1",
      groups: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  }

  async componentDidMount() {
    // Check view permission
    if (!checkPermission(this.props.loginUserData, "corporate_group", "view")) {
      notification["error"]({
        message: ACCESS_DENIED_MESSAGE,
        description: ACCESS_DENIED_MESSAGE_DESCRIPTION,
      });
      this.props.history.replace("/dashboard");
      return;
    }

    await this.fetchCorporateGroups();

    let editPrimaryColor = await localStorage.getItem("primary_color");

    try {
      const {setRouteName, setSearchText} = this.props
      await setRouteName("CORPORATEGROUP");
      await setSearchText(""); 

      this.setState({
        isLoading: true,
        primaryColor: editPrimaryColor,
      });

      // await this.fetchCorporateGroups();

      await this.listCorporateGroup()

    } catch(e){
      notification["error"]({
        message: "Corporate Group",
        description: "Something went wrong",
      })
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  async fetchCorporateGroups(pagination = this.state.pagination) {
    const { authToken, searchText, setlistCorporateGroup, setlistCorporateGroupTotal, history, setLoginFlag, setUserData, setUserToken } = this.props;

    this.setState({ isLoading: true });

    try {
      const skipNumber = (pagination.current - 1) * pagination.pageSize;
      const limitNumber = pagination.pageSize;
      const searchQuery = searchText || ""; 

      const response = await getCorporateGroups(
        authToken,
        skipNumber,
        limitNumber,
        searchQuery
      );

      console.log("Response: ", response);

      if (response.status === 200) {
        setlistCorporateGroup(response.data); // Store corporate group details in Redux
        setlistCorporateGroupTotal(response.total); // Store total count in Redux

        this.setState({
          groups: response.data || [],
          pagination: { ...pagination, total: response.total || 0 },
          corporateGroupsList: response.data,
          corporateGroupsTotal: response.total,
        });
      } else if (response.status === 401) {
        setLoginFlag(false);
        setUserData(null);
        setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (err) {
      console.error("Failed to fetch groups:", err);
    } finally {
      this.setState({ isLoading: false });
    }
}


  async listCorporateGroup(pagination = this.state.pagination) {
    const { authToken, searchText, setlistCorporateGroup, setlistCorporateGroupTotal,  history,
      setLoginFlag,
      setUserData,
      setUserToken } = this.props;

    this.setState({ isLoading: true });

    try {
      const skipNumber = (pagination.current - 1) * pagination.pageSize;
      const limitNumber = pagination.pageSize;
      const searchQuery = searchText || ""; 

      const response = await getCorporateGroups(
        authToken,
        skipNumber,
        limitNumber,
        searchQuery
      );

      console.log("Response: ", response)

      if (response === 200) {
        await setlistCorporateGroup(response.data)
        await setlistCorporateGroupTotal(response.data.total)

        this.setState({
          groups: response.data || [],
          isLoading: false,
          pagination: {
            ...pagination,
            total: response.total || 0,
          },

          corporateGroupsList: response.data,
          corporateGroupsTotal: response.total
        });
      } else if (response.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (err) {
      console.error("Failed to fetch groups:", err);
      this.setState({ isLoading: false });
    }
  }


  handleTableChange = (pagination) => {
    this.setState({ pagination }, () => this.fetchCorporateGroups(pagination));
  };

  handleSearchChange = (event) => {
    const { setSearchText } = this.props; // Assuming setSeachText is a Redux action
    setSearchText(event.target.value);
};

  render() {
    const { isLoading, groups, pagination, primaryColor } = this.state;

    return (
      <Fragment>
        <Title parent="Corporate Groups" title="corporate Groups" />
        <div className="container-fluid">
          {isLoading ? (
            <div style={{ marginLeft: "20px" }}>
              <Spin
                size="large"
                style={{ marginLeft: "480px", marginTop: "130px" }}
              />
            </div>
          ) : (
            <div>
              {checkPermission(this.props.loginUserData, "corporate_group", "create") && (
                <div
                  style={{
                    marginTop: "20px",
                    display: "inline-block",
                    width: "100%",
                    marginBottom: "20px",
                    paddingLeft: "14px",
                    paddingRight: "55px",
                  }}
                >
                  <div style={{ float: "left", cursor: "pointer" }}>
                    <AddCorporateUser
                      primaryColor={primaryColor}
                      onSubmit={this.addSubmit}
                      Token={this.props.authToken}
                      LoginData={this.props.loginUserData}
                      fetchData={this.fetchCorporateGroups.bind(this)}
                    />
                  </div>
                </div>
              )}

              <CorporateGroupRecordsTable
                data={groups}
                pagination={pagination}
                fetchData={this.fetchCorporateGroups.bind(this)}
                handleTableChange={this.handleTableChange.bind(this)}
                Token={this.props.authToken}
              />
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken, // Assuming authToken is stored in Redux state
  loginUserData: state.auth.loginUserData,
  searchText: state.auth.searchText
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setlistCorporateGroup: (listCorporateGroup) => {
      dispatch({
        type: "SET_LIST_CORPORATE_GROUP_DATA",
        listCorporateGroup: listCorporateGroup,
      });
    },
    setlistCorporateGroupTotal: (corporateGroupsTotal) => {
      dispatch({
        type: "SET_LIST_CORPORATE_GROUP_DATA_TOTAL",
        setlistCorporateGroupTotal: corporateGroupsTotal,
      });
    },
    setRouteName: (routeName) => {
      dispatch({
        type: "SET_ROUTE_NAME",
        routeName: routeName,
      });
    },
    setSearchText: (searchText) => {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: searchText,
      });
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Group));
